import { ChakraProvider } from "@chakra-ui/react";
import { Route, Routes } from "react-router-dom";
import "./App.css";

//import component
import Home from "./components/Home";
import NotFound from "./components/notfound";
import DynamicProject from "./components/projects/dynamicProject";
import DynamicNews from "./components/News/dynamicNews";

function App() {
  return (
    <ChakraProvider>
      <Routes>
        <Route path="/*" element={<Home />} />
        <Route path="projects/:projectName" element={<DynamicProject />} />
        <Route path="news/:news" element={<DynamicNews />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </ChakraProvider>
  );
}

export default App;
